export interface GallerySlide {
  title: string
  src: string
  alt: string
}

export const snatchPhases: string[] = [
  'Start',
  'First Pull',
  'Transition',
  'Extension',
  'Turnover',
  'Receive & Recover',
]

export const seeCoachSteps: string[] = [
  'See the position.',
  'See the bar path.',
  'See the error.',
  'See the correction.',
  'Choose the drill.',
  'Coach the athlete.',
]

export const gallerySlides: GallerySlide[] = [
  {
    title: 'One Lift — Six Connected Phases of the Snatch',
    src: 'https://cdn.magicpatterns.com/uploads/iwwwkeRfp9Kawwzp1Y72R6/Captura_de_pantalla_2026-09-27_031326.png',
    alt: 'Six-phase visual breakdown of the snatch with bar path and feet, knees, hips, shoulders and bar checkpoints for each phase',
  },
  {
    title: 'Error — Bar Loops Forward: Causes, Correction & Drills',
    src: 'https://cdn.magicpatterns.com/uploads/3QuBkdZ53nqkdTm6rMcVgK/Captura_de_pantalla_2026-09-27_031352.png',
    alt: 'Bar-path diagram comparing efficient vertical path against a forward loop, with causes, correction and two drills',
  },
  {
    title: 'High-Hang Snatch — Step-by-Step Progression',
    src: 'https://cdn.magicpatterns.com/uploads/rbLRXyYLxGSTJHdjGrCMGT/Captura_de_pantalla_2026-09-27_031417.png',
    alt: 'Five-step high-hang snatch sequence with beginner, standard and level-up options and foot position at receive',
  },
  {
    title: 'Receiving Position — Meet the Bar in a Strong Position',
    src: 'https://cdn.magicpatterns.com/uploads/qw3KwxUDxCXESDsb5pDr6k/Captura_de_pantalla_2026-09-27_031438.png',
    alt: 'Front and side views of the overhead squat receiving position with seven numbered technical checkpoints and balanced foot position',
  },
  {
    title: 'See the Error → Choose the Drill — Drill Selection Map',
    src: 'https://cdn.magicpatterns.com/uploads/r611FVHFtxvLz3RSaU1HLQ/Captura_de_pantalla_2026-09-27_031500.png',
    alt: 'Drill selection map matching eight common snatch errors to the corrective drill and coaching cue for each',
  },
]
